import { colors, fonts} from '../../shared/styles';

export const styles = {
  container: {
    textAlign: 'center',
    alignItems: 'center'
  },
  otherDateButton: {
    boxSizing: 'border-box',
    height: '35px',
    width: 155,
    border: '1px solid #16A9E1',
    borderRadius: 3,
    padding: 7,
    margin: 7.5,
    cursor: 'pointer',
    backgroundColor: colors.white
  },
  otherDateButtonContainer: {
    maxWidth: 510,
    textAlign: 'center',
    alignItems: 'center',
    margin: 'auto'
  },
  otherDateButtonText: {
    height: '15px',
    color: colors.blue,
    fontFamily: fonts.default,
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: '0.3px',
    lineHeight: '15px',
    textAlign: 'center',
  },
  lookingForMoreText: {
    height: '17px',
    width: '100%',
    color: colors.textColor,
    fontFamily: fonts.default,
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
    marginTop: 25
  },
  processiongIcon: {
    marginBottom: 25,
    marginTop: 40
  },
  processingText: {
    height: '22px',
    width: '100%',
    color: colors.textColor,
    fontFamily: fonts.default,
    fontSize: '18px',
    lineHeight: '22px',
    textAlign: 'center',
    marginBottom: 15
  },
  processingSubText: {
    width: '100%',
    color: colors.lightGrey6,
    fontFamily: fonts.default,
    fontSize: '12px',
    lineHeight: '17px',
    textAlign: 'center',
    marginBottom: 0,
    marginTop: 0,
  },
  showAllText:{
    height: '16px',
    color: colors.blue,
    fontFamily: fonts.default,
    fontSize:  '13px',
    lineHeight: '16px',
    textAlign: 'center',
    backgroundColor: colors.white,
    border: 'none',
    cursor: 'pointer'
  }
}



/** WEBPACK FOOTER **
 ** ./components/pendingResultsMessage/styles.js
 **/